module.exports = __webpack_public_path__ + "media/megamenu/USB-a9fe8276.svg";